<template>
	<div class="col-12 col-lg-6">
        <div class="row">               
         	<component-control-sort
         	:sortBy = "sortBy"
         	:sortWay = "sortWay"
         	@handleSortControl = "handleSortControl"
         	></component-control-sort>

         	<component-control-search
			:strSearch = "strSearch"
			@handleSearchControl = "handleSearchControl"
			@handleClearControl = "handleClearControl"
         	></component-control-search>
          
        </div>

      </div>
</template>
<script type="text/javascript">
	import ComponentControlSearch from './ComponentControlSearch.vue';
	import ComponentControlSort from './ComponentControlSort.vue';
	export default {
		name: "component-control",

		props: {
			strSearch: {type: String, default: ""},
			sortBy: {type: String, default: "Level"},
			sortWay: {type: String, default: "ASC"},
		},
		data: function(){
			return {

			}
		},
		components: {
			ComponentControlSearch,
			ComponentControlSort
		},
		methods: {
			handleSearchControl: function(data){				
				this.$emit("handleSearchControlApp", data);
				console.log("Emit in Control component");
			},
			handleClearControl: function(){
				this.$emit("handleClearApp");
			},

			handleSortControl: function(sortBy, sortWay){
								
				this.$emit("handleSortControlApp", sortBy, sortWay);

			}
		}
	}
</script>
<style type="text/css"></style>
